import { Phone20Regular } from '@fluentui/react-icons';
import {
  AttachOption,
  AttachOptionsWrapper,
  AttachPopupWrapper,
  AttachTitle,
  CloseBackground,
} from './AttachPopup.styled';
import { useServiceDeskContext } from 'src/context/ServiceDesk/ServiceDeskContext';
import { fileReader } from 'src/components/Tickets/components/desktop/TicketDetailsPopup/utils/FileReader';
import { EMPTY_FILE_UPLOAD_ERROR_MESSAGE } from 'src/tabs/constants/Tickets.constants';

export const AttachPopup = () => {
  const { toggleAttachOverlay, handleUploadedFile, handleShowErrorMessage } =
    useServiceDeskContext();
  const handleUploadFromDevice = () => {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.addEventListener('change', (event) => {
      const fileList = (event.target as HTMLInputElement).files;
      if (fileList && fileList.length > 0) {
        fileReader(fileList[0])
          .then((data) => {
            if (data.trim().length === 0) {
              handleShowErrorMessage(true, EMPTY_FILE_UPLOAD_ERROR_MESSAGE);
            } else {
              handleShowErrorMessage(false, '');
              handleUploadedFile(fileList[0], true);
            }
          })
          .catch((err) => {
            console.log(err);
            handleShowErrorMessage(true, EMPTY_FILE_UPLOAD_ERROR_MESSAGE);
          });
      }
    });
    fileInput.click();
    fileInput.remove();
    toggleAttachOverlay(false);
  };

  const handleCloseAttachOverlay = () => {
    toggleAttachOverlay(false);
  };
  return (
    <>
      <CloseBackground onClick={handleCloseAttachOverlay} />
      <AttachPopupWrapper>
        <AttachTitle>Attach</AttachTitle>
        <AttachOptionsWrapper>
          <AttachOption onClick={handleUploadFromDevice}>
            <Phone20Regular />
            This device
          </AttachOption>
        </AttachOptionsWrapper>
      </AttachPopupWrapper>
    </>
  );
};
